import React from 'react';

/**
 * Sliding on/off switch — the frosted stand-in for a native checkbox.
 * Renders as a real button with `role="switch"` so it stays keyboard- and
 * screen-reader-accessible.
 */
const Toggle = ({ checked, onChange, disabled, size = 14, label, style }) => {
  // 24x14 track with a 10px thumb at the default size.
  const trackW = Math.round(size * 1.72);
  const pad = 2;
  const knob = size - pad * 2;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: trackW,
        height: size,
        flex: `0 0 ${trackW}px`,
        padding: 0,
        border: 0,
        borderRadius: 999,
        background: checked ? 'var(--switch, var(--accent))' : 'var(--line-bright)',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        position: 'relative',
        transition: 'background 140ms var(--ease-out)',
        ...style,
      }}
    >
      <span style={{
        position: 'absolute',
        top: pad,
        left: checked ? trackW - knob - pad : pad,
        width: knob,
        height: knob,
        borderRadius: '50%',
        background: '#ffffff',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.18)',
        transition: 'left 140ms var(--ease-out)',
      }} />
    </button>
  );
};

export default Toggle;
